import React from 'react'
import '../styles/about.css'

import Fade from 'react-reveal/Fade'

function About() {
    return(
        <div className='about'>
            <Fade bottom>
                <h2 className='about-h2'>
                    <img src='/images/Rectangle.svg' alt='icon'/>
                    Наша компания
                    <img src='/images/Rectangle.svg' alt='icon'/>
                </h2>
            </Fade>
            
            <div className='about-content'>
                <Fade left>
                    <div className='about-text-block'>
                        <div className='about-p1'>
                            Наша компания предлагает <span className='about-highlight'>современные строительные материалы</span> физическим лицам и организациям. Все представленные строительные материалы проверены на практике и имеют высокое качество, подтвержденное сертификатами.
                        </div>
                        <div className='about-p2'>
                            Ознакомиться со списком предлагаемых к продаже строительных материалов можно в каталоге нашего сайта и в магазине по адресу <span className='about-highlight'>г. Жодино ул. Брестская, 29</span>. Вы можете приобрести необходимые строительные материалы и оформить доставку.
                        </div>
                        <div className='about-p3'>
                            Выбирая нас, вы получаете <span className='about-highlight'>надежного партнера</span>, который готов выполнять свои обязательства на высоком уровне. Вы можете рассчитывать на предоставление полной информации по предлагаемой строительной продукции и профессиональные рекомендации со стороны наших специалистов.
                        </div>
                    </div>
                </Fade>
                
                <Fade right>
                    <div className='about-images-block'>
                        <img src='/images/2.svg' className='about-image' alt='Строительные работы'/>
                        <img src='/images/3.svg' className='about-image' alt='Качество материалов'/>
                        <img src='/images/img.png' className='about-image large' alt='Наша компания'/>
                    </div>
                </Fade>
            </div>
        </div>
    )
}

export default About